import { HeaderService } from '@patsnap-utils/biz'
interface GlobalStore {
  headerService: HeaderService | null
}
export const globalStore: GlobalStore = {
  headerService: null,
}
